// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__sa2L_","text":"SelectPayment_text__3FftJ","title":"SelectPayment_title__NJOWw","btn":"SelectPayment_btn__2Efo5"};